<template>
  <div class="v2-boring-porn">
    <div class="row">
      <div class="col-md-7 col-lg-6">
        <div class="inner-container">
          <h2>{{ t("Stop watching boring porn") }}</h2>
          <lazy-component>
            <div class="cover w-100 d-md-none rounded-1 mb-3 ratio ratio-16x9" />
          </lazy-component>
          <p>
            {{
              t(
                "What's better than getting to know someone beautiful, then discovering her ultimate desires & watching them come to life? Come watch porn with us that makes you feel good about sex!",
              )
            }}
          </p>

          <div class="d-flex justify-content-center justify-content-md-start mt-4 mb-3 mb-md-0">
            <button v-modal.modal-signup class="btn btn-primary border-dark" @click="sendRegistrationTrack">
              {{ t("Discover Ersties") }}
            </button>
          </div>

          <span class="bg-sticker star-pink d-none d-lg-inline-block">
            <img v-lazy="starPinkDarkSticker" :alt="`sticker star`" width="24" height="24" />
          </span>

          <span class="bg-sticker star-nude-large d-none d-lg-inline-block">
            <img v-lazy="starNudeDarkSticker" :alt="`sticker star`" width="32" height="32" />
          </span>

          <span class="bg-sticker star-mint d-none d-lg-inline-block">
            <img v-lazy="starMintDarkSticker" :alt="`sticker star`" width="16" height="16" />
          </span>
        </div>
      </div>
      <lazy-component class="col-md-5 col-lg-6 d-none d-md-flex">
        <div class="cover rounded-1 position-relative h-100" />
      </lazy-component>
    </div>
  </div>
</template>

<script setup lang="ts">
import { amplitudeRegistrationButtonClickTrack } from "@/utils/amplitude";
import { useI18n } from "vue-i18n";
import starPinkDarkSticker from "@/assets/v2/images/stickers/star-pink-dark.svg";
import starNudeDarkSticker from "@/assets/v2/images/stickers/star-nude-dark.svg";
import starMintDarkSticker from "@/assets/v2/images/stickers/star-mint-dark.svg";

defineOptions({
  name: "boring-porn",
});

const { t } = useI18n();

const sendRegistrationTrack = () => {
  amplitudeRegistrationButtonClickTrack("boring porn");
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
